export const courseEnrolleeCount = (course, courseEnrollees = []) =>
    courseEnrollees.filter(ce => ce.courseId === course?.id).length + (course?.enrolled || 0);